<template>
  <component
    :is="tag"
    v-bind="linkProps"
    :class="linkClass"
    @click="handleClick"
  >
    <slot />
  </component>
</template>

<script>
import { navigateTo, parseNavRouteTo, scrollToHash, splitNavPath } from '@/utils/navigation'

export default {
  name: 'NavLink',
  props: {
    to: {
      type: String,
      default: '/'
    },
    href: {
      type: String,
      default: ''
    },
    external: {
      type: Boolean,
      default: false
    },
    linkClass: {
      type: [String, Object, Array],
      default: ''
    },
    exact: {
      type: Boolean,
      default: false
    },
    suppressActiveClass: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tag() {
      return this.external ? 'a' : 'router-link'
    },
    linkProps() {
      if (this.external) {
        return {
          href: this.href || this.to,
          rel: 'noopener noreferrer'
        }
      }

      const props = { to: parseNavRouteTo(this.to) }
      if (this.exact) props.exact = true
      if (this.suppressActiveClass) {
        props.activeClass = ''
        props.exactActiveClass = ''
      }
      return props
    }
  },
  methods: {
    handleClick(e) {
      if (this.external) {
        e.preventDefault()
        navigateTo(this.$router, {
          path: this.to,
          href: this.href || this.to,
          external: true
        })
        this.$emit('click', e)
        return
      }

      const { path: pathname, hash } = splitNavPath(this.to)
      if (!hash) {
        this.$emit('click', e)
        return
      }

      e.preventDefault()
      const routeTo = { path: pathname, hash }
      const { path: currentPath, hash: currentHash } = splitNavPath(
        `${this.$route.path}${this.$route.hash || ''}`
      )

      if (currentPath === pathname && currentHash === hash) {
        scrollToHash(hash)
      } else {
        this.$router.push(routeTo).catch(err => {
          if (err && err.name !== 'NavigationDuplicated') {
            throw err
          }
          scrollToHash(hash)
        })
      }

      this.$emit('click', e)
    }
  }
}
</script>
